'use client';
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import DashboardLayout from '@/components/DashboardLayout';
import { useAuth } from '@/lib/auth';
import Loader from '@/components/Loader';
import { AutumnProvider } from '@/components/AutumnProvider';
import { useEffect } from 'react';
import CompanySignupOnboarding from '@/components/Onboarding/CompanySignupOnboarding';

export const Route = createFileRoute('/_auth')({
  ssr: false,
  component: AuthLayout,
  head: () => ({
    title: 'Dashboard - GreetAI',
    meta: [
      {
        name: 'title',
        content: 'Dashboard - GreetAI',
      },
      {
        name: 'description',
        content: 'GreetAI Dashboard',
      },
    ],
  }),
});

function AuthLayout() {
  const { isAuthenticated, isInitialLoading, emailVerified, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInitialLoading && !isAuthenticated) {
      navigate({ to: '/login' });
    }
  }, [isInitialLoading, isAuthenticated, navigate]);

  useEffect(() => {
    if (!isInitialLoading && isAuthenticated && !emailVerified) {
      navigate({ to: '/verify-email' });
    }
  }, [isInitialLoading, isAuthenticated, emailVerified, navigate]);

  if (isInitialLoading) {
    return <Loader />;
  }
  if (!isAuthenticated) {
    return null;
  }
  if (!emailVerified) {
    return null;
  }
  if (user?.role === 'company_admin' && !user.onboarding_completed) {
    return <CompanySignupOnboarding />;
  }
  return (
    <AutumnProvider>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </AutumnProvider>
  );
}
